import type {ReduxStore} from 'src/reducers';
import IndexStore from 'src/stores';

import * as React from 'react';
import App from './app';
import AppRoutes from 'src/reroutes/app';

import {AskAI, useHandleAskAiEvents} from 'src/components/agentic-ui';


export default function SenseApp(props: {
  reduxStore: ReduxStore;
  senseStore: IndexStore;
}) {
  useHandleAskAiEvents(props.reduxStore);
  return (
    <App {...props}>
      <AppRoutes {...props} />
      <AskAI />
    </App>
  );
}
